export interface INotesTemplatesListDelegate {
    onAddOrUpdateNotesTemplateClicked(): void;
}
